module.exports = __webpack_public_path__ + "static/media/magnifier.110d8659.png";